<template>
  <BaseSvg
    class="notify-icon"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#847398"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </BaseSvg>
</template>

<script>
import BaseSvg from './BaseSvg.vue';

export default {
  name: 'SproutIcon',
  components: {
    BaseSvg,
  },
};
</script>
